export default [
  {
    path: "/received",
    name: "received",
    component: () => import("./pages/index.vue"),
    meta: {
      authRequired: true,
      layout: "main",
      title: "Поступления",
    },
  },
];
